import { retrieveErrorFromApi } from '../../../helper'
import { setWaiterCallsNotifications, setWaiterCallsWaiters } from '../../action/waiterCalls'
import { setAppErrors } from '../../action/system'
import getWaiters from '../../axios/kitchen/waiters/get'
import getWaiterNotifications from '../../axios/kitchen/waiterNotifications/get'
import createWaiterNotification from '../../axios/kitchen/waiterNotifications/post'
import updateWaiterNotification from '../../axios/kitchen/waiterNotifications/put'
import updateWaiterNotificationWaiterComing from '../../axios/kitchen/waiterNotifications/waiterComing/put'
import { fetchWaiterCallsThunk } from '../restaurant/waiterCall'

export const getWaitersThunk = () => dispatch => {
	return getWaiters()
		.then(res => {
			dispatch(setWaiterCallsWaiters(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getWaiterNotificationsThunk = (kitchenMonitorId) => dispatch => {
	return getWaiterNotifications(kitchenMonitorId)
		.then(res => {
			dispatch(setWaiterCallsNotifications(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const createWaiterNotificationThunk = (kitchenMonitorId, data) => dispatch => {
	return createWaiterNotification(data)
		.then(() => dispatch(getWaiterNotificationsThunk(kitchenMonitorId)))
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateWaiterNotificationThunk = (id, kitchenMonitorId, data) => dispatch => {
	return updateWaiterNotification(id, data).then(() => {
		return dispatch(getWaiterNotificationsThunk(kitchenMonitorId))
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const updateWaiterNotificationWaiterComingThunk = (id, data) => dispatch => {
	return updateWaiterNotificationWaiterComing(id, data)
		.then(() => {
			return dispatch(fetchWaiterCallsThunk())
		}).catch(error => {
			retrieveErrorFromApi(error)
		})
}
